import { Card, CardContent, Grid, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { SurveyRecord } from "../../generated/graphql"
import CorrectiveActionsDisplay from "../CorrectiveActionsDisplay/CorrectiveActionsDisplay"
import { PublishedRender } from "../Datagrid/Renders/PublishedRender"
import { SurveyRecordStateRender } from "../Datagrid/Renders/SurveyRecordStateRender"
import { FormatDateTime } from "../FormatDate/FormatDate"
import Show from "../Show/Show"
import styles from './SurveyRecordCard.module.scss'

interface SurveyRecordCardProps {
    record: SurveyRecord
}

export default function SurveyRecordCard(props: SurveyRecordCardProps) {
    const { record } = props

    const navigate = useNavigate()

    const handleCardClick = () => {
        navigate(`/survey-record/${record.id}`)
    }

    return (
        <Card className={styles.Card} onClick={handleCardClick}>
            <CardContent>
                <Grid container justifyContent="space-between" className={styles.Header} alignItems="center">
                    <Typography variant="h6" color="primary">
                        {record.name}
                    </Typography>
                    <SurveyRecordStateRender row={{ state: record.state, size: "small" }} />
                </Grid>

                <Grid container direction="column" className={styles.Info}>
                    <Typography variant="body2" color="textSecondary">
                        <b>Contrato:</b> {record.contract.name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        <b>Via:</b> {record.road.name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        <b>Data:</b> <FormatDateTime datetime={record.surveyedAt} />
                    </Typography>
                </Grid>

                <Grid container justifyContent="flex-start" className={styles.Status} gap={1}>

                    <PublishedRender row={{ isPublished: record.isPublished }} />

                    <Show on={record?.hasCorrectiveRequests}>
                        <CorrectiveActionsDisplay count={record?.openCorrectiveRequests} />
                    </Show>
                </Grid>
            </CardContent>
        </Card>
    )
}
